import type { ReactNode } from "react";

import type { AgentCompany } from "../api/e2e";
import CompanyWorkspaceHeader from "./CompanyWorkspaceHeader";

export default function CompanyWorkspacePage({
  companies,
  company,
  children,
  className,
}: {
  companies: readonly AgentCompany[];
  company: AgentCompany;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={[
        "page",
        "page--workspace",
        "page--fixed-company-header",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <CompanyWorkspaceHeader companies={companies} company={company} />
      <div className="company-workspace-scroll">{children}</div>
    </div>
  );
}
